module.exports = __webpack_public_path__ + "images/emoji/rainbow.179508221a972524d9a9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rainbow.png
// module id = kTlp
// module chunks = 2